import { ApiClient } from '@/shared/api-client/api-client';
import { ISpeakerRequest } from '@/shared/api-client/models/speaker/speaker-request';
import { ArgumentValidator } from '@/shared/helpers/argument-validator';
import { StringComparer } from '@/shared/helpers/string-comparer';
import { UIEventHandler } from '@/shared/helpers/ui-event-handler';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SpeakerQueueListComponent extends Vue {

    @Prop({ default: () => [] }) public queue!: ISpeakerRequest[];
    @Prop({ default: undefined }) public currentUserId!: string;
    @Prop({ default: false }) public isLoading!: boolean;
    @Prop({ default: '' }) public doneClass!: string;
    @Prop({ default: '' }) public emptyText!: string;
    @Prop({ default: () => ({}) }) public translations!: { [key: string]: string };

    private apiClient: ApiClient = new ApiClient();
    private showProposals: string[] = [];

    public currentUsersRequest(req: ISpeakerRequest): boolean {

        if (this.currentUserId === undefined || !req.userId) {
            return false;
        }

        return this.currentUserId.toLowerCase() === req.userId.toLowerCase();
    }

    public async cancelClicked(activityId: string, speakerRequestId: string, $event?: UIEvent): Promise<void> {

        UIEventHandler.preventDefaults($event);

        ArgumentValidator.notNullOrEmpty(activityId, 'activityId');
        ArgumentValidator.notNullOrEmpty(speakerRequestId, 'speakerRequestId');

        if (!confirm(this.translations['general_confirm'])) {
            return;
        }

        await this.apiClient.speakerRequest.cancel(activityId, speakerRequestId);

        this.$emit('cancelled');
    }

    public toggleProposal(req: ISpeakerRequest, $event?: UIEvent) {

        UIEventHandler.preventDefaults($event);

        if (this.showProposal(req)) {
            this.showProposals = this.showProposals.filter(x => x !== req.id)
        } else {
            this.showProposals.push(req.id)
        }
    }

    public showProposal(req: ISpeakerRequest): boolean {
        return !StringComparer.isNullOrEmpty(req.proposal) && this.showProposals.includes(req.id);
    }
}
